import { AlignmentType, FrameAnchorType, HorizontalPositionAlign, Paragraph, TextRun, VerticalPositionAlign, WidthType } from "docx";

export function reportAppName(certInApplicationName) {
    return new Paragraph({
        width: { size: 50, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { line: 276, before: 100, after: 100 },
        frame: {
            type: "absolute",
            position: {
                x: 700,
                y: 6000,
            },
            width: 9000,
            height: 1000,
            anchor: {
                horizontal: FrameAnchorType.MARGIN,
                vertical: FrameAnchorType.MARGIN,
            },
            alignment: {
                x: HorizontalPositionAlign.CENTER,
                y: VerticalPositionAlign.CENTER,
            },
            zIndex: 90,
        },

        children: [
            new TextRun({
                text: "Source Code Security Audit Report of " + certInApplicationName,
                font: "Calibri",
                size: 56,
                color: '0070C0',
                allCaps: false,
                italics: false
            }),
        ],
    });
}


export function reportAppDate(dateString) {
    const date = new Date(dateString);

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        else {
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        }
    }

    const formattedDate = `${date.getDate()}`;
    const ordinalSuffix = getOrdinalSuffix(date.getDate());
    const formatMonth = (date.getMonth() + 1).toString();
    const formatYear = date.getFullYear();

    return new Paragraph({
        width: { size: 70, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { line: 276, before: 100, after: 100 },
        frame: {
            type: "absolute",
            position: {
                x: 700,
                y: 9500,
            },
            width: 9000,
            height: 1000,
            anchor: {
                horizontal: FrameAnchorType.MARGIN,
                vertical: FrameAnchorType.MARGIN,
            },
            alignment: {
                x: HorizontalPositionAlign.CENTER,
                y: VerticalPositionAlign.CENTER,
            },
            zIndex: 90,
        },

        children: [
            new TextRun({
                text: "Report Submission Date: ",
                font: "Calibri",
                size: 56,
                color: '0070C0',
                allCaps: false,
                italics: false
            }),
            new TextRun({
                text: formattedDate,
                font: "Calibri",
                size: 56,
                color: '0070C0',
                italics: false
            }),
            new TextRun({
                text: '-' + formatMonth + '-' + formatYear,  // Format month as a number
                font: "Calibri",
                size: 56,
                color: '0070C0',
                italics: false
            })
        ],
    });
}